import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sSRListActive'
})
export class SSRListActivePipe implements PipeTransform {

  transform(value: any[]): any {
    return value[value.length - 1]; // Return the last item
  }

}
